import { Outlet } from 'react-router-dom';
import { cn } from '@/shared/lib/utils';
import { useAppSelector } from '@/app/store';
import {
  selectSidebarOpen,
  selectSidebarHovered,
  selectDirection,
  selectIsMobile,
} from '@/app/store/slices/ui.slice';
import { SIDEBAR_CONFIG } from '@/shared/constants';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { MobileDrawer } from './MobileDrawer';

export function MainLayout() {
  const isOpen = useAppSelector(selectSidebarOpen);
  const isHovered = useAppSelector(selectSidebarHovered);
  const direction = useAppSelector(selectDirection);
  const isMobile = useAppSelector(selectIsMobile);

  const effectiveOpen = isOpen || isHovered;

  // Calculate content margin based on sidebar state
  const contentMargin = effectiveOpen
    ? SIDEBAR_CONFIG.WIDTH_EXPANDED
    : SIDEBAR_CONFIG.WIDTH_COLLAPSED;

  return (
    <div className="min-h-screen bg-white">
      {/* Sidebar - Desktop */}
      {!isMobile && <Sidebar />}

      {/* Mobile Drawer */}
      {isMobile && <MobileDrawer />}

      {/* Main Content */}
      <div
        className={cn(
          'flex flex-col min-h-screen transition-all duration-300',
          !isMobile && (direction === 'rtl' ? 'mr-auto' : 'ml-auto')
        )}
        style={{
          width: isMobile ? '100%' : `calc(100% - ${contentMargin}px)`,
        }}
      >
        {/* Navbar */}
        <Navbar />

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
